<template>
  <div>
    <!-- 添加模板表对话框 -->
    <el-dialog
        title="添加模板表"
        :visible.sync="addDialogVisible"
        width="600px"
        append-to-body
        @close="addDialogClosed"
    >
      <el-form
          ref="addFormRef"
          :model="addForm"
          :rules="rules"
          label-width="80px"
      >
        <el-row>
          <el-col :span="24">
            <el-form-item label="模板名称" prop="name">
              <el-input v-model="addForm.name" placeholder="请输入模板名称"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="模板路径" prop="path">
              <el-input v-model="addForm.path" placeholder="请输入模板路径"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="模板内容" prop="content">
              <el-input v-model="addForm.content" placeholder="请输入模板内容"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="模板关键字" prop="keyword">
              <el-input v-model="addForm.keyword" placeholder="请输入模板关键字"/>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="模板备注" prop="brief">
              <el-input v-model="addForm.brief" placeholder="请输入模板备注"/>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="addTemplate">确 定</el-button>
        <el-button @click="cancel">取 消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import {addTemplate} from "@/api/template/template";
import {getData} from "@/utils/code";

export default {
  name: "addTemplate",
  data() {
    return {
      addForm: {}, //添加组织表单
      addDialogVisible: false,
      // 规则
      rules: {
            name: [{required: true, message: "模板名称不能为空", trigger: "blur"}],
            path: [{required: true, message: "模板路径不能为空", trigger: "blur"}],
            content: [{required: true, message: "模板内容不能为空", trigger: "blur"}],
            keyword: [{required: true, message: "模板关键字不能为空", trigger: "blur"}],
            brief: [{required: true, message: "模板备注不能为空", trigger: "blur"}],
      },
    }
  },
  methods: {
    cancel() {
      this.addDialogVisible = false
      this.addForm = {}
    },
    addDialog() {
      this.addDialogVisible = true
    },
    // 监听添加用户对话框的关闭事件 /  重置表单
    addDialogClosed() {
      this.addForm = {}
    },
    // 添加
    addTemplate() {
      this.$refs.addFormRef.validate(async (valid) => {
        if (!valid) return;
        addTemplate(this.addForm).then((response) => {
          let data = getData(response)
          if (data !== null) {
            this.$emit('refresh-list')
            this.addDialogVisible = false;
          }
        })
      });
    },

  }
}
</script>

<style scoped>

</style>